module.exports = __webpack_public_path__ + "static/media/eu.aee07e03.svg";